import { ajaxRequest } from "../../Utils/Ajax/ajax"
import { successToast } from "../../Utils/utils"


export function loadPasswordReset(){

    $("#reset-password").on("click", function(e){
        e.preventDefault()
        const btn = $(this)
        const form = $("#forgot-pw-form")

        const data = $(form).serializeArray()
        const url = '/reset-password'
    
        const success = function(data){
            btn.prop('disabled', true)
            successToast("Dein Passwort wurde geändert. Du wirst zur Anmeldung umgeleitet.")
            setTimeout(function(){
                window.location = data.redirect_url
            }, 1300)
        }
    
        ajaxRequest(url, success, data, $(this))
    })

}